import moment from "moment";

import { Link } from "react-router-dom";

const TerminCard = ({ item }) => {
  return (
    <Link
      to={`/termine/${item.slug}`}
      class="block rounded-lg p-4 shadow-md shadow-indigo-100 hover:shadow-lg  font-roboto "
    >
      <img
        alt={item.title}
        src={item.foto[0].url}
        class="h-56 w-full rounded-md object-cover"
      />

      <div class="mt-2">
        <dl>
          <div className="grid grid-cols-2 ">
            <dt class="sr-only">Termin</dt>

            <dd class="text-sm text-gray-500">
              <i class="fi fi-rr-calendar-clock"></i>{" "}
              {moment(item.startDate).format("DD.MM.YYYY")}
            </dd>
          </div>

          <div className="mt-1">
            <dt class="sr-only">Titel</dt>

            <dd class="font-medium">{item.title}</dd>
          </div>
          <div className="mt-1">
            <dt class="sr-only">Beschreibung</dt>
            <dd class="text-sm text-gray-500"> {item.description}</dd>
          </div>

          <Link
            class="inline-block rounded mt-2  px-8 py-3 text-sm font-medium text-white transition hover:rotate-2 hover:scale-110 focus:outline-none focus:ring"
            style={
              item.color.hex === null
                ? { backgroundColor: "#941F1F" }
                : { backgroundColor: item.color.hex }
            }
            to={`/termine/${item.slug}`}
          >
            Mehr erfahren
          </Link>
        </dl>
      </div>
    </Link>
  );
};

const NoTerminCard = ({
  item = {
    title: "Keine Termine",
    description: "Es sind keine Termine verfügbar",
  },
}) => {
  return (
    <div class="block rounded-lg p-4 shadow-md shadow-indigo-100 hover:shadow-lg  font-roboto ">
      <svg
        viewBox="0 0 1024 1024"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className=" w-full rounded-md object-cover h-32 hidden md:block "
      >
        <rect fill="#888888" fill-opacity="0.1" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M332 405C332 388.431 345.431 375 362 375H662C678.569 375 692 388.431 692 405V619C692 635.569 678.569 649 662 649H362C345.431 649 332 635.569 332 619V405ZM452 455C452 477.091 434.091 495 412 495C389.909 495 372 477.091 372 455C372 432.909 389.909 415 412 415C434.091 415 452 432.909 452 455ZM393 599H630.5C637.127 599 642.5 593.627 642.5 587V528.971C642.5 525.788 641.236 522.736 638.985 520.485L584.985 466.485C580.299 461.799 572.701 461.799 568.015 466.485L487.485 547.015C482.799 551.701 475.201 551.701 470.515 547.015L443.985 520.485C439.299 515.799 431.701 515.799 427.015 520.485L384.515 562.985C382.264 565.236 381 568.288 381 571.471V587C381 593.627 386.373 599 393 599Z"
          fill="#888888"
          fill-opacity="0.2"
        />
      </svg>

      <div class="mt-2">
        <dl>
          <div className="mt-1">
            <dt class="sr-only">Titel</dt>

            <dd class="font-medium">{item.title}</dd>
          </div>
          <div className="mt-1">
            <dt class="sr-only">Beschreibung</dt>
            <dd class="text-sm text-gray-500"> {item.description}</dd>
          </div>

          <p class="inline-block rounded mt-2  px-8 py-3 text-sm font-medium text-white bg-gray-600">
            Mehr erfahren
          </p>
        </dl>
      </div>
    </div>
  );
};

export { TerminCard, NoTerminCard };
